export default "__VITE_ASSET__Dfad2_fa__"